import { render } from "./NavFooter.vue?vue&type=template&id=507391ac&scoped=true"
import script from "./NavFooter.vue?vue&type=script&lang=js"
export * from "./NavFooter.vue?vue&type=script&lang=js"

import "./NavFooter.vue?vue&type=style&index=0&id=507391ac&lang=scss&scoped=true"

import exportComponent from "F:\\VueProject\\aoying-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507391ac"]])

export default __exports__